$(document).ready(function () {
  
    $("details.mega-menu summary.list-menu__item").hover(function () {
    $(this).parents("details.mega-menu").attr("open", "open");
  });

  
  window.addEventListener("wheel", (event) => {
    const seenBlock = document.querySelector("#mainSeenBlockSections");
    const seeScroll = document.querySelector("#mainSeenBlockSlider");

    if (
      seenBlock &&
      window.pageYOffset > seenBlock.offsetTop - seenBlock.offsetHeight
    ) {
      seeScroll.scrollBy({ left: event.deltaY < 0 ? -200 : 200 });
      // $(seenBlock).css("overflow" , "hidden");
      // $(seeScroll).css("margin" , "0 -150px");
    }
  });

  $(document).on("click", ".gridVariant .varinput", function () {
    var variantId = $(this).attr("data-variantId");
    var varPrice = $(this).data("price");
    $(this).parents(".card-information").find(".default_price").text(varPrice);
    $(this)
      .closest(".addBtn")
      .find(".customForm .product-variant-id")
      .val(variantId);
  });

  $(".imainGreasistGallerySlide")
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      speed: 300,
      autoplaySpeed: 2000,
      cssEase: "linear",
      infinite: true,
      asNavFor: ".imainGreasistNavbarSlide",
    })
    .on("setPosition", function (event, slick) {
      slick.$slides.css("height", slick.$slideTrack.height() + "px");
    });
  $(".imainGreasistNavbarSlide").slick({
    slidesToShow: 5,
    slidesToScroll: 0,
    infinite: false,
    focusOnSelect: true,
    asNavFor: ".imainGreasistGallerySlide",
    dots: false,
    arrows: false,
    centerMode: true,
  });
  $(".imainGreasistNavbarSlide").slick("slickGoTo", 1);

  $(document).on("click", ".greasist-block .block-heading", function () {
    var tab_id = $(this).attr("data-tab");
    $(".greasist-block .block-heading").removeClass("is__active");
    $(".main-block-content").removeClass("is__active");
    $(this).addClass("is__active");
    $("#" + tab_id).addClass("is__active");
  });

  $(".testimonialGridListSlider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    fade: false,
    dots: true,
  });

  if ($(window).width() < 990) {
    $("#columnGridListInstagram").slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      arrows: false,
      dots: false,
      cssEase: "linear",
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      swipeToSlide: true,
      centerMode: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

   // ------------product-sticky-add-to-cart------------//
   var stickyScrollDiv = document.querySelector(".main-productGrid");
   var productSticky = document.querySelector(".product--single__sticky");
   var mainSticky = document.querySelector("body")
  if (productSticky != null) {
   window.onscroll = function(){ stickyAddToCart() }; 
    // var sticky = stickyScrollDiv.offsetHeight;
    var sticky = stickyScrollDiv.offsetTop;
    function stickyAddToCart() { 
    if (window.pageYOffset > sticky) {
     productSticky.classList.add("is-sticky");
     mainSticky.classList.add("product-is-sticky"); 
    } else {
    productSticky.classList.remove("is-sticky"); 
    mainSticky.classList.remove("product-is-sticky"); 
    }
    }
  }
  $(document).on("click",".productSticky-button .productSticky-addcartbutton", function(){
   $(document).find('.product-form__buttons .product-form__submit').trigger("click");
    $(this).find(".stickyAdd_to_cartText").hide();
    $(this).find(".loading__spinner").removeClass("hidden"); 
     setTimeout(()=>{ 
        $(this).find(".stickyAdd_to_cartText").show();
        $(this).find(".loading__spinner").addClass("hidden"); 
     }, 2500);  
  });

   var mainProductGrid = document.querySelector(".main-productGrid");
if (mainProductGrid != null) {
class Accordion {
  constructor(el) { 
    this.el = el; 
    this.summary = el.querySelector('summary'); 
    this.content = el.querySelector('.accordion__content'); 
    this.animation = null; 
    this.isClosing = false; 
    this.isExpanding = false; 
    this.summary.addEventListener('click', (e) => this.onClick(e));
  } 
  onClick(e) { 
    e.preventDefault(); 
    this.el.style.overflow = 'hidden'; 
    if (this.isClosing || !this.el.open) {
      this.open(); 
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  } 
  shrink() { 
    this.isClosing = true; 
    const startHeight = `${this.el.offsetHeight}px`; 
    const endHeight = `${this.summary.offsetHeight}px`; 
    if (this.animation) { 
      this.animation.cancel();
    } 
    this.animation = this.el.animate({ 
      height: [startHeight, endHeight]
    }, {
      duration: 500,
      easing: 'ease-out'
    }); 
    this.animation.onfinish = () => this.onAnimationFinish(false); 
    this.animation.oncancel = () => this.isClosing = false;
  } 
  open() { 
    this.el.style.height = `${this.el.offsetHeight}px`; 
    this.el.open = true; 
    window.requestAnimationFrame(() => this.expand());
  } 
  expand() { 
    this.isExpanding = true; 
    const startHeight = `${this.el.offsetHeight}px`; 
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`; 
    if (this.animation) { 
      this.animation.cancel();
    } 
    this.animation = this.el.animate({ 
      height: [startHeight, endHeight]
    }, {
      duration: 500,
      easing: 'ease-out'
    }); 
    this.animation.onfinish = () => this.onAnimationFinish(true); 
    this.animation.oncancel = () => this.isExpanding = false;
  } 
  onAnimationFinish(open) { 
    this.el.open = open; 
    this.animation = null; 
    this.isClosing = false;
    this.isExpanding = false; 
    this.el.style.height = this.el.style.overflow = '';
  }
} 
document.querySelectorAll('details.details__accordion').forEach((el) => {
  new Accordion(el);
});
}

    // -----------start-colllection-js------------// 

  
$(document).on("click",".customTagFilter label.facets__label",function() { 
 if ($(this).hasClass("active")){
 $(this).removeClass("active");
 } else { 
  $(document).find('.customTagFilter label.facets__label').removeClass("active");
 $(this).addClass("active"); 
 }
});
  
$(document).on("click","#Details-sortFilter label.facets__label",function() { 
 var value = $(this).attr("data-value"); 
   $(document).find('.facets-vertical select.facet-filters__sort').val(value);
    $(".facets-vertical select").find("option").removeAttr("selected");
    $(".facets-vertical select").find("option").each(function () {
    if ($(this).val() == value) {
    $(this).attr("selected", true);
    }
    }); 
 });

  $(document).on("click",".collectionsNav--filter .collectionsNav--filter-btn",function() {  
    $(this).toggleClass("is-active"); 
   $(document).find('.collectionsNav--filter #all-collectionslink').slideToggle('500'); 
 });

   //  $(document).on("click",".tagFilter--wrapper .filter-list-title",function() {  
 //   $(document).find('.tagFilter--wrapper .blog--tagFilter-list').slideToggle('slow'); 
 // });
// -----------end-colllection-js------------//
});

  //------------blog-page-filter----------//
  
$(document).on("click",".tagFilter--wrapper .filter-list-title",function() {  
   $(document).find('.tagFilter--wrapper .blog--tagFilter-list').slideToggle('slow'); 
 });
